import { PropsWithChildren } from "react";
import LanguageProvider from "containers/Shared/LanguageProvider";
import { translationMessages } from "i18n";

// FIXME: LanguageProvider is the worst thing ever
export function InternationalizationProvider(props: PropsWithChildren) {
  return (
    <LanguageProvider messages={translationMessages}>
      {props.children}
    </LanguageProvider>
  );
}
